export interface ObjectivePrintOptions {
  includeObjective: boolean
  includeItem: boolean
  includePassages: boolean
  includeResponse: boolean
}

export type PrintedObjectiveOptions = ObjectivePrintOptions & { has_passages: boolean }

export function partHeading(index: number): string {
  return `Part ${index + 1}`
}

// "CCSS.ELA-Literacy.RL.3.1" prints as "RL.3.1"; maths refs carry an extra "Math.Content" segment.
export function shortCcssRef(longRef: string): string {
  const leadingSegmentCount = longRef.includes('Math.Content') ? 3 : 2
  return longRef.split('.').slice(leadingSegmentCount).join('.')
}
